import { api } from '@/components/Functional/lib/request'
import { logger } from '@/components/Functional/utils/logger'
import { SpotGetResponseSchema, SpotListResponseSchema } from '@/schemas/v2'
import type { SpotGetResponse, SpotListResponse } from '@/schemas/v2'
import {
  SpotAudioGuideResponseSchema,
  SpotCouponRedeemResponseSchema,
  SpotCouponsResponseSchema,
  SpotPhotoFrameResponseSchema,
} from '@/schemas/v2/spot'
import type {
  SpotAudioGuideResponse,
  SpotCouponRedeemResponse,
  SpotCouponsResponse,
  SpotPhotoFrameResponse,
} from '@/schemas/v2/spot'

const BASE = process.env.NEXT_PUBLIC_API_URL ?? ''

type FetchOptions = { headers?: Record<string, string> }

export async function fetchSpots(options?: FetchOptions): Promise<SpotListResponse> {
  const url = `${BASE}/api/v2/spots`
  logger.info({ fetch_method: 'GET', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.get<unknown>(url, options)
    return SpotListResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'GET', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}

export async function fetchSpot(id: number, options?: FetchOptions): Promise<SpotGetResponse> {
  const url = `${BASE}/api/v2/spots/${id}`
  logger.info({ fetch_method: 'GET', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.get<unknown>(url, options)
    return SpotGetResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'GET', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}

export async function fetchSpotWithLocation(
  id: number,
  latitude: number,
  longitude: number,
  options?: FetchOptions,
): Promise<SpotGetResponse> {
  const url = `${BASE}/api/v2/spots/${id}?lat=${latitude}&lon=${longitude}`
  logger.info({ fetch_method: 'GET', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.get<unknown>(url, options)
    return SpotGetResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'GET', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}

export async function fetchSpotCoupons(id: number, options?: FetchOptions): Promise<SpotCouponsResponse> {
  const url = `${BASE}/api/v2/spots/${id}/coupons`
  logger.info({ fetch_method: 'GET', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.get<unknown>(url, options)
    return SpotCouponsResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'GET', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}

export async function postSpotPhotoFrames(
  id: number,
  body?: Record<string, unknown>,
  options?: FetchOptions,
): Promise<SpotPhotoFrameResponse> {
  const url = `${BASE}/api/v2/spots/${id}/photo-frames`
  logger.info({ fetch_method: 'POST', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.post<unknown>(url, body, options)
    return SpotPhotoFrameResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'POST', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}

export async function postSpotAudioGuides(
  id: number,
  body?: Record<string, unknown>,
  options?: FetchOptions,
): Promise<SpotAudioGuideResponse> {
  const url = `${BASE}/api/v2/spots/${id}/audio-guides`
  logger.info({ fetch_method: 'POST', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.post<unknown>(url, body, options)
    return SpotAudioGuideResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'POST', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}

export async function postSpotCouponRedeem(
  spotId: number,
  couponId: number,
  options?: FetchOptions,
): Promise<SpotCouponRedeemResponse> {
  const url = `${BASE}/api/v2/spots/${spotId}/coupons/${couponId}`
  logger.info({ fetch_method: 'POST', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.post<unknown>(url, {}, options)
    return SpotCouponRedeemResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'POST', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}
